import { DeclaredDocumentsFormDataProps } from '../../../../../../components/Documents/DeclaredDocumentsCreate';
import {
  AdditionalDocumentFormDataProps,
  previewAdditionalDocument,
} from '../../../../../../components/Forms/Steps/AdditionalDocument';
import {
  ConfirmationOfApplication,
  ConfirmationOfApplicationFormDataProps,
} from '../../../../../../components/Forms/Steps/ConfirmationOfApplication';
import { InsuranceFormDataProps, previewInsuranceData } from '../../../../../../components/Forms/Steps/InsuranceData';
import {
  PersonalAndPassportFormDataProps,
  previewPersonalAndPassportData,
} from '../../../../../../components/Forms/Steps/PersonalAndPassportData';
import {
  PlaceOfResidenceFormDataProps,
  previewPlaceOfResidence,
} from '../../../../../../components/Forms/Steps/PlaceOfResidence';
import {
  TechnicalConditionFormDataProps,
  previewTechnicalCondition,
} from '../../../../../../components/Forms/Steps/TechnicalConditionData';
import { previewWeaponsData } from '../../../../../../components/Forms/Steps/WeaponsData';

interface Props {
  formData: {
    weaponType?: string;
  } & PlaceOfResidenceFormDataProps &
    DeclaredDocumentsFormDataProps &
    AdditionalDocumentFormDataProps &
    TechnicalConditionFormDataProps &
    InsuranceFormDataProps &
    PersonalAndPassportFormDataProps &
    ConfirmationOfApplicationFormDataProps;
  handleInputChange: (name: string, value: unknown) => void;
}

const Step9: React.FC<Props> = ({ formData, handleInputChange }) => {
  return (
    <ConfirmationOfApplication
      formData={formData}
      handleInputChange={handleInputChange}
      accordionData={[
        previewWeaponsData({
          selectedWeapon: {
            weapon: formData.weaponType,
          },
        }),
        previewPersonalAndPassportData({ formData }),
        previewPlaceOfResidence({ formData }),
        previewInsuranceData({ formData }),
        previewTechnicalCondition({ formData }),
        previewAdditionalDocument({ formData }),
      ]}
    />
  );
};

export default Step9;
